var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLowPolyGridHaikei1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 1280 640",
    width: 1280,
    height: 640,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1,
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M588.9 358L537.9 290L465.7 367Z",
    fill: "#1d4e6b",
    stroke: "#1d4e6b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.9 290L431.7 287L465.7 367Z",
    fill: "#1d4e6b",
    stroke: "#1d4e6b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.7 367L576.9 481L588.9 358Z",
    fill: "#1d4e6b",
    stroke: "#1d4e6b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.1 484L730.1 402L588.9 358Z",
    fill: "#081a28",
    stroke: "#081a28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.9 358L730.1 257L537.9 290Z",
    fill: "#297ea6",
    stroke: "#297ea6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.4 393L386.7 517L465.7 367Z",
    fill: "#297ea6",
    stroke: "#297ea6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.7 367L386.7 517L576.9 481Z",
    fill: "#081a28",
    stroke: "#081a28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.9 481L700.1 484L588.9 358Z",
    fill: "#15384f",
    stroke: "#15384f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.9 640L700.1 484L576.9 481Z",
    fill: "#1d4e6b",
    stroke: "#1d4e6b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.1 402L730.1 257L588.9 358Z",
    fill: "#00101c",
    stroke: "#00101c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.9 290L424.7 123L431.7 287Z",
    fill: "#205a7a",
    stroke: "#205a7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.1 131L575.9 123L537.9 290Z",
    fill: "#15384f",
    stroke: "#15384f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.4 259L282.4 393L431.7 287Z",
    fill: "#112e42",
    stroke: "#112e42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.7 287L282.4 393L465.7 367Z",
    fill: "#0c2435",
    stroke: "#0c2435"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.7 123L294.4 259L431.7 287Z",
    fill: "#00101c",
    stroke: "#00101c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.9 123L424.7 123L537.9 290Z",
    fill: "#19435d",
    stroke: "#19435d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.1 257L674.1 131L537.9 290Z",
    fill: "#00101c",
    stroke: "#00101c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.4 393L314.4 521L386.7 517Z",
    fill: "#112e42",
    stroke: "#112e42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.7 640L576.9 481L386.7 517Z",
    fill: "#0c2435",
    stroke: "#0c2435"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.7 640L572.9 640L576.9 481Z",
    fill: "#112e42",
    stroke: "#112e42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.1 484L817.3 387L730.1 402Z",
    fill: "#297ea6",
    stroke: "#297ea6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.1 402L817.3 387L730.1 257Z",
    fill: "#00101c",
    stroke: "#00101c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.1 257L850.3 164L674.1 131Z",
    fill: "#112e42",
    stroke: "#112e42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.3 500L817.3 387L700.1 484Z",
    fill: "#205a7a",
    stroke: "#205a7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.4 640L464.7 640L386.7 517Z",
    fill: "#081a28",
    stroke: "#081a28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.7 0L306.4 119L424.7 123Z",
    fill: "#00101c",
    stroke: "#00101c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.7 123L306.4 119L294.4 259Z",
    fill: "#0c2435",
    stroke: "#0c2435"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.2 360L172.2 486L282.4 393Z",
    fill: "#205a7a",
    stroke: "#205a7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.9 640L717.1 640L700.1 484Z",
    fill: "#00101c",
    stroke: "#00101c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.3 387L852.3 236L730.1 257Z",
    fill: "#00101c",
    stroke: "#00101c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.1 131L590.9 0L575.9 123Z",
    fill: "#00101c",
    stroke: "#00101c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.9 123L416.7 0L424.7 123Z",
    fill: "#112e42",
    stroke: "#112e42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.1 0L590.9 0L674.1 131Z",
    fill: "#1d4e6b",
    stroke: "#1d4e6b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.9 0L416.7 0L575.9 123Z",
    fill: "#0c2435",
    stroke: "#0c2435"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.1 640L869.3 500L700.1 484Z",
    fill: "#081a28",
    stroke: "#081a28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.3 387L961.6 370L852.3 236Z",
    fill: "#00101c",
    stroke: "#00101c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.6 242L850.3 164L852.3 236Z",
    fill: "#112e42",
    stroke: "#112e42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M852.3 236L850.3 164L730.1 257Z",
    fill: "#0c2435",
    stroke: "#0c2435"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.4 393L172.2 486L314.4 521Z",
    fill: "#277297",
    stroke: "#277297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.4 521L249.4 640L386.7 517Z",
    fill: "#246688",
    stroke: "#246688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.2 360L282.4 393L294.4 259Z",
    fill: "#081a28",
    stroke: "#081a28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.2 486L249.4 640L314.4 521Z",
    fill: "#00101c",
    stroke: "#00101c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.3 164L720.1 0L674.1 131Z",
    fill: "#081a28",
    stroke: "#081a28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.2 256L121.2 360L294.4 259Z",
    fill: "#112e42",
    stroke: "#112e42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.2 101L294.4 259L306.4 119Z",
    fill: "#246688",
    stroke: "#246688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.2 101L124.2 256L294.4 259Z",
    fill: "#277297",
    stroke: "#277297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.4 0L179.2 101L306.4 119Z",
    fill: "#246688",
    stroke: "#246688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.1 640L846.3 640L869.3 500Z",
    fill: "#081a28",
    stroke: "#081a28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.6 534L961.6 370L869.3 500Z",
    fill: "#1d4e6b",
    stroke: "#1d4e6b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.3 500L961.6 370L817.3 387Z",
    fill: "#277297",
    stroke: "#277297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.7 0L246.4 0L306.4 119Z",
    fill: "#112e42",
    stroke: "#112e42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.3 164L866.3 0L720.1 0Z",
    fill: "#1d4e6b",
    stroke: "#1d4e6b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.6 113L866.3 0L850.3 164Z",
    fill: "#205a7a",
    stroke: "#205a7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M961.6 370L1013.6 242L852.3 236Z",
    fill: "#15384f",
    stroke: "#15384f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 372L172.2 486L121.2 360Z",
    fill: "#00101c",
    stroke: "#00101c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 550L103.2 640L172.2 486Z",
    fill: "#00101c",
    stroke: "#00101c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.2 486L103.2 640L249.4 640Z",
    fill: "#00101c",
    stroke: "#00101c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.3 640L1011.6 534L869.3 500Z",
    fill: "#297ea6",
    stroke: "#297ea6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M961.6 370L1118.8 420L1013.6 242Z",
    fill: "#112e42",
    stroke: "#112e42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 101L0 235L124.2 256Z",
    fill: "#00101c",
    stroke: "#00101c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.4 0L145.2 0L179.2 101Z",
    fill: "#15384f",
    stroke: "#15384f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.2 256L0 372L121.2 360Z",
    fill: "#0c2435",
    stroke: "#0c2435"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 235L0 372L124.2 256Z",
    fill: "#00101c",
    stroke: "#00101c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 101L124.2 256L179.2 101Z",
    fill: "#297ea6",
    stroke: "#297ea6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1161.8 124L1016.6 113L1013.6 242Z",
    fill: "#1d4e6b",
    stroke: "#1d4e6b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.6 242L1016.6 113L850.3 164Z",
    fill: "#246688",
    stroke: "#246688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 372L0 550L172.2 486Z",
    fill: "#00101c",
    stroke: "#00101c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.3 640L1014.6 640L1011.6 534Z",
    fill: "#1d4e6b",
    stroke: "#1d4e6b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.6 534L1118.8 420L961.6 370Z",
    fill: "#0c2435",
    stroke: "#0c2435"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.2 0L0 101L179.2 101Z",
    fill: "#081a28",
    stroke: "#081a28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.6 113L999.6 0L866.3 0Z",
    fill: "#081a28",
    stroke: "#081a28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102.8 540L1118.8 420L1011.6 534Z",
    fill: "#277297",
    stroke: "#277297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.6 113L1150.8 0L999.6 0Z",
    fill: "#112e42",
    stroke: "#112e42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 550L0 640L103.2 640Z",
    fill: "#277297",
    stroke: "#277297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.6 640L1102.8 540L1011.6 534Z",
    fill: "#297ea6",
    stroke: "#297ea6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280 357L1148.8 260L1118.8 420Z",
    fill: "#246688",
    stroke: "#246688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118.8 420L1148.8 260L1013.6 242Z",
    fill: "#19435d",
    stroke: "#19435d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.2 0L0 0L0 101Z",
    fill: "#1d4e6b",
    stroke: "#1d4e6b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.8 260L1161.8 124L1013.6 242Z",
    fill: "#081a28",
    stroke: "#081a28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.6 640L1159.8 640L1102.8 540Z",
    fill: "#081a28",
    stroke: "#081a28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280 507L1280 357L1118.8 420Z",
    fill: "#15384f",
    stroke: "#15384f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.8 260L1280 157L1161.8 124Z",
    fill: "#297ea6",
    stroke: "#297ea6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1161.8 124L1150.8 0L1016.6 113Z",
    fill: "#112e42",
    stroke: "#112e42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280 507L1118.8 420L1102.8 540Z",
    fill: "#277297",
    stroke: "#277297"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1161.8 124L1280 0L1150.8 0Z",
    fill: "#1d4e6b",
    stroke: "#1d4e6b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280 357L1280 295L1148.8 260Z",
    fill: "#15384f",
    stroke: "#15384f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.8 640L1280 507L1102.8 540Z",
    fill: "#15384f",
    stroke: "#15384f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280 295L1280 157L1148.8 260Z",
    fill: "#112e42",
    stroke: "#112e42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.8 640L1280 640L1280 507Z",
    fill: "#297ea6",
    stroke: "#297ea6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280 157L1280 0L1161.8 124Z",
    fill: "#112e42",
    stroke: "#112e42"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowPolyGridHaikei1);
export default __webpack_public_path__ + "static/media/low-poly-grid-haikei (1).3dc018f3d9c98e685603646bdc2f66d9.svg";
export { ForwardRef as ReactComponent };